import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Button } from '../dialog-buttons.component';

import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'smart-sorted-dialog',
    templateUrl: './smart-sorted-dialog.component.html',
    styleUrls: [
        './smart-sorted-dialog.component.scss',
        '../dialog.scss',
    ],
    standalone: false
})
export class SmartSortedDialogComponent extends DialogComponent
{
  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    super(dialogData);
    this.buttons = {
      primary: Button.WITH_SMART_SORTED,
      secondary: Button.WITHOUT_SMART_SORTED,
    };
  }
}
